import { render } from "./TermsEnglish.vue?vue&type=template&id=8cd0e684"
import script from "./TermsEnglish.vue?vue&type=script&lang=js"
export * from "./TermsEnglish.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__